import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-carta-img-arrb',
  templateUrl: './carta-img-arrb.component.html',
  styleUrls: ['./carta-img-arrb.component.css']
})
export class CartaImgArrbComponent implements OnInit {

  @Input() imagen: string
  @Input() descripcion: string

  ngOnInit(): void {
  }

}
